import { getSalesTeamCrud } from 'legacy/lut/components/widgets/public/partner360/helpers/hpContactRoles/getSalesTeamCrud'
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react'

import { Logic, Operator } from 'core-components/types'
import { useMeasureController } from 'core/analytics/useMeasureController'

interface IUseLeadPbmIdProps {
  partnerId: string
}

export const useLeadPbmId = ({
  partnerId,
}: IUseLeadPbmIdProps): [number, Dispatch<SetStateAction<number>>] => {
  /** -------------------- Variables ----------------------- */
  const [leadPbmId, setLeadPbmId] = useState(-1)

  const crudPbm = getSalesTeamCrud()
  const { startLoadData, stopLoadData } = useMeasureController('lead-pbm-id')

  /** -------------------- Methods ----------------------- */
  const fetchLeadPbm = useCallback(
    async (force?: boolean) => {
      startLoadData()

      const result = await crudPbm.fetch({ force })
      if (result.items.length > 0) {
        const [first] = result.items
        setLeadPbmId(first.EntryId)
      }

      stopLoadData()
    },
    [crudPbm, startLoadData, stopLoadData]
  )

  /** -------------------- Effects ----------------------- */
  useEffect(() => {
    crudPbm.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'Partner_ID',
          operator: Operator.EQUAL,
          value: partnerId,
        },
        {
          field: 'LeadPBM',
          operator: Operator.EQUAL,
          value: 1,
        },
      ],
    })

    fetchLeadPbm()
  }, [crudPbm, fetchLeadPbm, partnerId])

  return [leadPbmId, setLeadPbmId]
}
